export interface MusicTrack {
  title: string
  artist: string
  src: string
}

export const musicTracks: MusicTrack[] = [
  { title: '利兹与青鸟', artist: '原声音乐', src: '/audio/07-liz-and-the-blue-bird.mp3' },
  { title: '星晴', artist: '周杰伦', src: '/audio/01-xing-qing.mp3' },
  { title: '搁浅', artist: '周杰伦', src: '/audio/02-ge-qian.mp3' },
  { title: '七里香', artist: '周杰伦', src: '/audio/03-qi-li-xiang.mp3' },
  { title: '稻香', artist: '周杰伦', src: '/audio/04-dao-xiang.mp3' },
  { title: '珊瑚海', artist: '周杰伦 / 梁心颐', src: '/audio/05-shan-hu-hai.mp3' },
  { title: '龙卷风', artist: '周杰伦', src: '/audio/06-long-juan-feng.mp3' },
]
